<template>
  <v-app>
    <Menu />
    <content>
      <router-view> </router-view>
    </content>
    <v-footer height="auto" color="red">
      <v-layout justify-center row wrap>
        <v-btn color="white" to="/subscription-terms&conditions" flat
          >Subscription Terms & Conditions</v-btn
        >
        <v-btn color="white" to="/privacy-policy-en" flat>Privacy policy</v-btn>
        <v-btn color="white" to="/company-docs" flat>Company Docs</v-btn>
        <v-btn color="white" to="/terms-&-conditions" flat>
          Terms & Conditions
        </v-btn>
        <!-- <v-btn color="white" to="/user-delete-request" flat>
          User Delete Request
        </v-btn> -->
        <v-flex text-xs-center white--text xs12>
          &copy;{{ getYear() }} —
          <strong>DataDash</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Menu from "@/components/Menu";

export default {
  name: "App",
  components: {
    Menu,
  },

  data() {
    return {
      clipped: false,
      sideNav: false,
      fixed: false,
      clientId: null,
      admin_access: [
        "System Settings",
        "Project Settings",
        "Reports",
        "User Role",
        "Clementine",
        "Project",
      ],
    };
  },

  computed: {
    ...mapGetters(["isLoggedIn", "clientID", "getMenus"]),
  },
  methods: {
    ...mapActions(["login", "logout"]),

    redirectToWebsite() {
      window.open("https://clementinedatabd.com/");
    },
    getMenuData(value) {
      var filterMemu = value;
      this.setSubscription();
      if (parseInt(localStorage.getItem("client_id")) != 1) {
        filterMemu = value.filter((element) => {
          return !this.admin_access.includes(element.title);
        });
        return filterMemu;
      }
      return value;
    },
    checkClient() {
      // console.log(localStorage.getItem("client_id"));
      return parseInt(localStorage.getItem("client_id")) == 1 ? true : false;
    },
    setSubscription() {
      if (this.isLoggedIn) {
        this.$store.dispatch("subscriptionData", "subscription-features");
      }

      // console.log("subscriptionData");
    },
    getYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
